export const ENABLE_WHEN_EXPRESSION_URL =
	"http://hl7.org/fhir/uv/sdc/StructureDefinition/sdc-questionnaire-enableWhenExpression";
export const MIN_VALUE_URL = "http://hl7.org/fhir/StructureDefinition/minValue";
export const MAX_VALUE_URL = "http://hl7.org/fhir/StructureDefinition/maxValue";
export const REGEX_URL = "http://hl7.org/fhir/StructureDefinition/regex";
export const MIN_OCCURS_URL = "http://hl7.org/fhir/StructureDefinition/questionnaire-minOccurs";
export const MAX_OCCURS_URL = "http://hl7.org/fhir/StructureDefinition/questionnaire-maxOccurs";
export const CONSTRAINT_URL = "http://hl7.org/fhir/StructureDefinition/questionnaire-constraint";
export const ORDINAL_VALUE_URL = "http://hl7.org/fhir/StructureDefinition/ordinalValue";
export const ITEM_WEIGHT_URL = "http://hl7.org/fhir/StructureDefinition/itemWeight";
